import React from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, TextSpace } from '@garnish/core';
import { type AddressType } from '@garnish/location';

import { BagChannelHeader } from '../BagChannelHeader';
import {
  BagLocationFromConnector,
  BagLocationHeader,
  BagLocationToConnector,
} from '../BagLocationHeader';

/**
 * Shortened header for order channel and location.
 */
export const BagChannelAndLocationInfo = (props: BagChannelAndLocationInfoProps) => {
  const {
    orderChannel,
    locationName,
    isDisabled,
    requestChannelOrLocationChange,
    requestDeliveryPreferencesChange,
  } = props;

  return (
    <BodyText style={styles.headerText} sizeMatch={['16']} numberOfLines={1}>
      {orderChannel === 'outpost' ? null : (
        <BagChannelHeader
          nonFocusable
          accessibilityRole="link"
          isDisabled={isDisabled}
          orderChannel={orderChannel}
          requestChannelOrLocationChange={requestChannelOrLocationChange}
        />
      )}

      {orderChannel === 'outpost' ? null : <TextSpace />}

      {orderChannel === 'pickup' ? <BagLocationFromConnector /> : null}

      {orderChannel === 'delivery' ? <BagLocationToConnector /> : null}

      {orderChannel === 'outpost' ? null : <TextSpace />}

      <BagLocationHeader
        nonFocusable
        accessibilityRole="link"
        isDisabled={isDisabled}
        orderChannel={orderChannel}
        locationName={locationName}
        requestDeliveryPreferencesChange={requestDeliveryPreferencesChange}
        requestChannelOrLocationChange={requestChannelOrLocationChange}
      />
    </BodyText>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerText: {
    textAlign: 'center',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type BagChannelAndLocationInfoProps = {
  orderChannel: AddressType;
  locationName: string;
  isDisabled?: boolean;
  requestChannelOrLocationChange: () => void;
  requestDeliveryPreferencesChange: () => void;
};
